
import { Vue, Component, Watch } from "vue-property-decorator";
import ApplyForm from "@/components/ApplyForm.vue";
import ManageModule from "./components/ManageModule.vue";
import ScienceModule from "./components/ScienceModule.vue";
import GrowthModule from "./components/GrowthModule.vue";
import ManageGrowModule from "./components/ManageGrowModule.vue";
import TalentModule from "./components/TalentModule.vue";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { formatUpyunUrl } from "@/utils";
// import {openJesongChat} from "easy"
import { generateMetaInfo, getServiceJsonLd, getFaqJsonLd, getItemListJsonLd, injectJsonLd } from "@/utils/seo";

@Component({
  components: {
    ApplyForm,
    ManageModule,
    ScienceModule,
    GrowthModule,
    ManageGrowModule,
    TalentModule,
    Breadcrumb
  }
})
export default class Accompany extends Vue {
  get metaInfo() {
    return generateMetaInfo({
      title: "咨询陪跑 | 管理微咨询·科学经营·人才·管理·增长陪跑 - 光华赋能",
      description:
        "光华赋能20年专注企业管理与培训，提供管理微咨询、科学经营陪跑、人才陪跑、管理陪跑、增长陪跑服务。周期短、见效快、费用低，覆盖企业战略、商业模式、股权设计、组织优化、绩效管理、薪酬体系、企业文化等领域。",
      keywords:
        "咨询陪跑,管理微咨询,企业咨询,战略咨询,股权设计,组织优化,绩效管理,薪酬体系,企业文化,企业陪跑,光华赋能",
      path: "/accompany",
      breadcrumb: [
        { name: "首页", url: "/" },
        { name: "咨询陪跑" }
      ],
      jsonLd: getServiceJsonLd({
        name: "企业咨询陪跑",
        description:
          "提供管理微咨询、科学经营陪跑、人才陪跑、管理陪跑、增长陪跑服务，覆盖战略、股权、组织、绩效、薪酬、文化等领域。",
        category: "企业管理咨询"
      })
    });
  }

  formatUpyunUrl = formatUpyunUrl;
  pic1 = "/img/9e5e8f4e97cf740b0b43ed8226bdacfb.png";
  tabIndex: any = 0;
  List = [{ title: "咨询陪跑", url: "" }];
  applyType = "";
  @Watch("$route.query.tab")
  tabChange() {
    this.init();
  }
  created() {
    console.log(123456);

    this.init();
  }
  init() {
    console.log("this.$route.query.tab", this.$route.query.tab);

    this.tabIndex = this.$route.query.tab ? Number(this.$route.query.tab) : 0;
    if (this.tabIndex == 0) {
      this.List = [{ title: "管理微咨询", url: "" }];
      this.applyType = "申请报名管理微咨询";
    } else if (this.tabIndex == 1) {
      this.List = [{ title: "科学经营陪跑", url: "" }];
      this.applyType = "申请报名科学经营陪跑";
    } else if (this.tabIndex == 2) {
      this.List = [{ title: "人才陪跑", url: "" }];
      this.applyType = "申请报名人才陪跑";
    } else if (this.tabIndex == 3) {
      this.List = [{ title: "管理陪跑", url: "" }];
      this.applyType = "申请报名管理陪跑";
    } else if (this.tabIndex == 4) {
      this.List = [{ title: "增长陪跑", url: "" }];
      this.applyType = "申请报名增长陪跑";
    }
    let apply = this.$refs.apply as any;
    apply.refresh();
  }

  changeTab(index: number) {
    this.tabIndex = index;
    if (this.tabIndex == 0) {
      this.applyType = "申请报名管理微咨询";
    } else if (this.tabIndex == 1) {
      this.applyType = "申请报名科学经营陪跑";
    } else if (this.tabIndex == 2) {
      this.applyType = "申请报名人才陪跑";
    } else if (this.tabIndex == 3) {
      this.applyType = "申请报名管理陪跑";
    } else if (this.tabIndex == 4) {
      this.applyType = "申请报名增长陪跑";
    }
    let apply = this.$refs.apply as any;
    apply.refresh();
  }

  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "咨询培训，微咨询，科学经营陪跑，人才陪跑，管理陪跑，增长陪跑"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "体系僵硬、人才断层、效率底下、战略受阻、管理陪跑，管理微咨询，增长陪跑，科学经营陪跑，人才陪跑，共建商学院，人才梯队，人才密度，人才敬业度，内生动力，高质量发展，体系化，系统化，发展机制，资源，能力，经验，目标管理，组织体系（含薪酬、绩效、股权、主流程等）人才体系，文化体系，组织体系人才管理体系，绩效体系，薪酬激励体系，内部流程体系，文化体系"
    );
    document.head.appendChild(metaTag2);
    // 注入 FAQPage JSON-LD
    injectJsonLd(
      "jsonld-faq",
      getFaqJsonLd([
        {
          question: "光华咨询陪跑是什么？",
          answer: "光华咨询陪跑是光华赋能为企业提供的深度陪跑服务，包括管理微咨询、科学经营陪跑、人才陪跑、管理陪跑、增长陪跑等，通过专家入驻+工具+方法论，帮助企业解决体系僵硬、人才断层、效率低下、战略受阻等问题。"
        },
        {
          question: "咨询陪跑适合什么企业？",
          answer: "咨询陪跑适合遇到增长瓶颈、组织管理混乱、人才梯队缺失、战略落地困难的成长型企业，特别是有一定规模但需要系统化提升管理能力的企业。"
        },
        {
          question: "咨询陪跑的服务周期是多久？",
          answer: "咨询陪跑根据企业需求和项目复杂度，服务周期从3个月到1年不等，采用阶段性目标管理，确保每个阶段都有可衡量的成果。"
        },
        {
          question: "咨询陪跑和传统咨询有什么区别？",
          answer: "传统咨询以方案交付为主，光华咨询陪跑更注重落地执行，专家团队深入企业一线，手把手辅导企业把方案变成结果，确保效果看得见。"
        }
      ])
    );
    // 注入 ItemList JSON-LD（相关知识推荐）
    injectJsonLd(
      "jsonld-related-knowledge",
      getItemListJsonLd([
        { name: "科学经营™", url: "/scientific-management" },
        { name: "BLM方法论", url: "/blm" },
        { name: "分拆对™工作法", url: "/fenchaidui" }
      ])
    );
  }
  beforeDestroy() {
    // 移除之前添加的meta标签，防止内存泄漏
    const metas1 = document.head.querySelectorAll('meta[name="keywords"]');
    metas1.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
    const metas2 = document.head.querySelectorAll('meta[name="description"]');
    metas2.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
  }
}
